import {
  findIndexByPropertyValue
} from 'utilities/collection';

class System {

  constructor() {

    this.supportedFonts = [];

  }

  getBuiltInFontFamilies() {

    const options = [{
      name: 'Neue Helvetica',
      value: 'Neue Helvetica'
    }, {
      name: 'Arial',
      value: 'Arial'
    }, {
      name: 'Times New Roman',
      value: 'Times New Roman'
    }, {
      name: 'Courier',
      value: 'Courier'
    }];

    return options;

  }

  getExternalFontFamilies() {

    return this.getSupportedFonts();

  }

  findExternalFontFamily(fontFamily) {

    const externalFonts = this.getExternalFontFamilies();
    const index = findIndexByPropertyValue(externalFonts, 'name', fontFamily);

    if (index === -1) {
      return null;
    }

    return externalFonts[index];

  }

  getFontFamilies() {

    const builtInFonts = this.getBuiltInFontFamilies();
    const externalFonts = this.getSupportedFonts();

    return builtInFonts.concat(JSON.parse(JSON.stringify(externalFonts)));

  }

  isExternalFontFamily(fontFamily) {

    return this.findExternalFontFamily(fontFamily) !== null;

  }

  setSupportedFonts(supportedFonts) {

    this.supportedFonts = supportedFonts;

  }

  getSupportedFonts() {

    return this.supportedFonts;

  }

}

export default System;